var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2497 8.75005C13.7497 11.25 11.8647 13.604 9.21974 14.13C7.92973 14.3869 6.59155 14.2303 5.39574 13.6824C4.19993 13.1346 3.20746 12.2234 2.55963 11.0786C1.91181 9.93389 1.64165 8.61393 1.78765 7.30672C1.93364 5.99951 2.48833 4.77167 3.37274 3.79805C5.18674 1.80005 8.24974 1.25005 10.7497 2.25005",
    stroke: "#672EBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7.75L8.25 10.25L14.25 3.75",
    stroke: "#672EBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseTick);
export default __webpack_public_path__ + "static/media/course-tick.b2bc7937438d971e4dc39f917b1f6477.svg";
export { ForwardRef as ReactComponent };